import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://public.readdy.ai/ai/img_res/9f17768f-557a-422c-acf8-71d99eebfaaf.png" 
              alt="LBA Construct Logo" 
              className="h-14 w-auto"
            />
          </a>
          
          <nav className="hidden md:flex items-center gap-8">
            <a 
              href="#diensten" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
              }`}
            >
              Diensten
            </a>
            <a 
              href="#waarom-lba" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
              }`}
            >
              Waarom LBA
            </a>
            <a 
              href="#realisaties" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
              }`}
            >
              Realisaties
            </a>
            <a 
              href="#contact-form" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
              }`}
            >
              Contact
            </a>
          </nav>

          <a 
            href="#contact-form" 
            className="hidden md:block bg-red-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Offerte Aanvragen
          </a>

          <button 
            onClick={handleMobileMenuToggle}
            className="md:hidden text-gray-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${isScrolled ? 'text-gray-700' : 'text-white'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <div 
          className={`md:hidden transition-all duration-300 overflow-hidden ${
            isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <nav className="py-4 space-y-4 bg-white rounded-lg shadow-lg mt-2 px-4">
            <a 
              href="#diensten" 
              onClick={handleLinkClick}
              className="block text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors cursor-pointer py-2"
            >
              Diensten
            </a>
            <a 
              href="#waarom-lba" 
              onClick={handleLinkClick}
              className="block text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors cursor-pointer py-2"
            >
              Waarom LBA
            </a>
            <a 
              href="#realisaties" 
              onClick={handleLinkClick}
              className="block text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors cursor-pointer py-2"
            >
              Realisaties
            </a>
            <a 
              href="#contact-form" 
              onClick={handleLinkClick}
              className="block text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors cursor-pointer py-2"
            >
              Contact
            </a>
            <a 
              href="#contact-form" 
              onClick={handleLinkClick}
              className="block bg-red-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-red-700 transition-colors text-center cursor-pointer whitespace-nowrap"
            >
              Offerte Aanvragen
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
